// utils/printUtils.js
export const printHtmlContent = (htmlContent, options = {}) => {
  const {
    title = 'ஸ்ரீ பொன்னாச்சி அம்மன் திருக்கோவில்கள், அத்திப்பாளையம்',
    logoUrl = '/logo192.png',
    header = 'ஸ்ரீ பொன்னாச்சி அம்மன் திருக்கோவில்கள், அத்திப்பாளையம்',
    footer = '[Authorized Signature / Footer Note]',
    statementTitle = '',
    website = 'https://sriponnachiammantemples.in',
    phone = '9943475494',
    email = 'sriponnachiammantemples@gmail.com',
  } = options;

  const printWindow = window.open('', '', 'width=900,height=700');

  printWindow.document.write(`
   <html>

<head>
  <title>${title}</title>
  <style>
    @media print {
      @page {
        size: A4 portrait;
        margin: 1cm;
      }

      body {
        margin: 0;
        padding: 0;
      }
    }

    body {
      font-family: Arial, sans-serif;
      color: #000;
      margin: 0;
      padding: 0;
    }

    .logo-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin: 0px 0;
    }

    .logo-header img {
      height: 50px;
      margin-right: auto;
    }

    .header-text {
      text-align: center;
      flex: 1;
      margin-right: 10px;
    }

    .statement-title {
      margin: 10px 0;
      text-align: center;
      font-size: 16px;
      font-weight: bold;
    }

    table {
      width: 100%;
      border-collapse: collapse;
      font-size: 12px;
      margin-top: 10px;
    }

    th,
    td {
      border: 1px solid #444;
      padding: 6px;
      text-align: left;
    }

    footer {
      margin-top: 10px;
      font-size: 10px;
      color: #666;
      text-align: center;
    }

    .devotional-banner {
      display: flex;
      justify-content: center;
      align-items: center;
      font-weight: bold;
      font-size: 16px;
      margin-top: 10px;
      margin-bottom: 10px;
      text-align: center;
      gap: 20px;
      flex-wrap: wrap;
    }

    .devotional-banner span {
      white-space: nowrap;
    }

    .center-symbol {
      font-size: 20px;
      margin: 0 10px;
    }

    .social-icons {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 5px;
      gap: 10px;
      flex-wrap: wrap;
    }

    .social-icon {
      width: 20px;
      height: 20px;
      object-fit: contain;
      filter: grayscale(100%) brightness(0);
      /* Black color */
    }


    @page {
      @bottom-center {
        content: "பக்கம் " counter(page) " / " counter(pages);
        font-size: 10px;
        color: #333;
      }
    }
  </style>
</head>

<body>
  <div class="devotional-banner">
    <span class="left-text">ஸ்ரீ பொன்னாசி அம்மன் துணை!</span>
    <span class="center-symbol">௳</span>
    <span class="right-text">ஸ்ரீ கருமலையான் துணை!</span>
  </div>
  <div class="logo-header">

    <div class="header-text">
      <h2>${header}</h2>
      ${statementTitle ? `<div class="statement-title">${statementTitle}</div>` : ''}
    </div>
    <img src="${logoUrl}" alt="Logo" />
  </div>

  <div class="content">
    ${htmlContent}
  </div>

  <footer>
    <p>${footer}</p>
    <div class="footer-info">
      🌐 <a href="${website}">${website}</a> 
      📞 ${phone} 
      📧 <a href="mailto:${email}">${email}</a>
    </div>

    <div class="social-icons">
      <a href="https://play.google.com/store/apps/details?id=com.sriponnachiammantemples.test" target="_blank">
        <img src="https://cdn.jsdelivr.net/npm/simple-icons@v9/icons/android.svg" alt="Android" class="social-icon" />
      </a>
      <a href="http://sriponnachiammantemples.in/register" target="_blank">
        <img src="https://cdn.jsdelivr.net/npm/simple-icons@v9/icons/apple.svg" alt="Apple" class="social-icon" />
      </a>
      <a href="https://whatsapp.com/channel/0029Vamg0f21dAvzNUTrPf2d" target="_blank">
        <img src="https://cdn.jsdelivr.net/npm/simple-icons@v9/icons/whatsapp.svg" alt="WhatsApp" class="social-icon" />
      </a>
      <a href="https://instagram.com/sriponnachiammantemples" target="_blank">
        <img src="https://cdn.jsdelivr.net/npm/simple-icons@v9/icons/instagram.svg" alt="Instagram"
          class="social-icon" />
      </a>
      <a href="https://facebook.com/yourpage" target="_blank">
        <img src="https://cdn.jsdelivr.net/npm/simple-icons@v9/icons/facebook.svg" alt="Facebook" class="social-icon" />
      </a>

      <a href="https://youtube.com/@SriPonnachiAmmanTemples" target="_blank">
        <img src="https://cdn.jsdelivr.net/npm/simple-icons@v9/icons/youtube.svg" alt="YouTube" class="social-icon" />
      </a>
sriponnachiammantemples (Sri Ponnachi Amman Temples, Athipalayam)

    </div>
  </footer>

</body>

</html>
    `);

  printWindow.document.close();
  printWindow.print();
};
